import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, Row, Select } from "antd";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  addTransactionField,
  updateTransactionField
} from "../../../../actions/companySettings";
import { findLodash, objectToFormData } from "../../../../utils";
import InputSelect from "../../../Analytics/InputSelect";
import "./../../styles/setting.css";
const { Option } = Select;

const ValidationSchema = yup.object().shape({
  column_name: yup.string().required("Please provide name"),
  column_type: yup.string().required("Please provide data type"),
  default_values: yup.mixed().when('column_type', {
    is: 'dropdown',
    then: yup.array().of(yup.object().shape({
      id: yup.string().required(),
      level: yup.string().required(),
    })).required().min(1),
    otherwise: yup.mixed()
  }),
  categories: yup.mixed().when('isCat', {
    is: true,
    then: yup.array().of(yup.string()).required().min(1),
    otherwise: yup.mixed()
  })


  // categories : yup.string().required("please select category")
});

const AddExpenseField = (props) => {
  const { id: currentId } = props;
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      column_name: "",
      column_type: "",
      is_required: false,
      categories: [],
      default_values: [{ id: 1, level: '' }, { id: 2, level: '' }],
      isCat: false


    },

    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const payload = {};
      ["column_name", "column_type", "is_required", "is_enable", "categories"].forEach(
        (item) => {
          payload[item] = values[item] || false;
        }
      );
      //  const default_values = fieldsData.map((item) => item.level);
      const default_values = values?.default_values?.map(item => item.level);

      if (values.column_type === 'dropdown') {
        payload.default_values = [...default_values];
      }

      Object.keys(payload).forEach(key => {
        if (!payload[key] && key !== "is_required" && key !== "is_enable") {
          delete payload[key];
        }
      });

      currentId ?
        dispatch(updateTransactionField(objectToFormData({ ...payload, id: currentId.toString() }))) :
        dispatch(addTransactionField(objectToFormData({ ...payload })));
    }


  });

  const [fieldsDeleteData, setFieldsDeleteData] = React.useState([]);
  const transactionFieldResponse = useSelector(
    (state) => state.companySetting.getTransactionField || {}
  );

  const categories = useSelector(
    (state) => state.categories.categories?.data?.response?.categories || []
  );
  const [isAll, setIsAll] = useState(false);
  // React.useEffect(() => {
  //   formik.resetForm();

  //   if (transactionFieldResponse.success && currentId) {
  //     const editValues = findLodash(
  //       transactionFieldResponse.data.response.fields,
  //       { id: currentId }
  //     );
  //     formik.setValues({
  //       column_name: editValues.column_name,
  //       column_type: editValues.column_type,
  //       is_required: editValues.is_required,
  //       is_enable: editValues.is_enable,
  //       categories: editValues.categories ?? [],
  //       default_values: editValues.default_values?.map((ele, idx) => ({ id: idx + 1, level: ele })),
  //       isCat: editValues.categories?.length > 0
  //     });

  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props]);

  React.useEffect(() => {
  formik.resetForm();

  if (transactionFieldResponse.success && currentId) {
    const editValues = findLodash(
      transactionFieldResponse.data.response.fields,
      { id: currentId }
    );

    // ✅ normalize default_values
    let defaultValues = [];

    if (Array.isArray(editValues.default_values) && editValues.default_values.length > 0) {
      defaultValues = editValues.default_values.map((val, idx) => ({
        id: idx + 1,
        level: val
      }));
    } else {
      // If backend gives null or empty, start with one empty input
      defaultValues = [{ id: 1, level: "" }];
    }

    formik.setValues({
      column_name: editValues.column_name,
      column_type: editValues.column_type?.toLowerCase(), // 🔑 Normalize to lowercase to match your <Option value="dropdown">
      is_required: editValues.is_required,
      is_enable: editValues.is_enable,
      categories: editValues.categories ?? [],
      default_values: defaultValues,
      isCat: editValues.categories?.length > 0
    });
  }
}, [props]);

  const handleCancelButton = () => {
    formik.resetForm();
    props.handleCancel();
  };



  // const handleFields = (type, key) => {
  //   const fieldsData = formik.values.default_values ? formik.values.default_values : []

  //   if (type === "add") {
  //     formik.setFieldValue('default_values', [...fieldsData, { id: fieldsData.length + 1, level: "" }]);
  //   } else {
  //     setFieldsDeleteData([...fieldsDeleteData, key]);
  //     const filterArray = fieldsData.filter((obj) => obj.id !== key);
  //     // filterArray.forEach((item, index) => { item['id'] = index + 1 });
  //     //setFieldsData([...filterArray]);
  //     formik.setFieldValue('default_values', [...filterArray]);
  //   }
  // };

  const handleFields = (type, key) => {
    const fieldsData = formik.values.default_values || [];

    if (type === "add") {
      // ✅ Use a guaranteed unique ID like a timestamp
      const newId = Date.now();
      formik.setFieldValue('default_values', [...fieldsData, { id: newId, level: "" }]);
    } else {
      // Your remove logic is already correct as it creates a new array via .filter()
      setFieldsDeleteData([...fieldsDeleteData, key]);
      const filterArray = fieldsData.filter((obj) => obj.id !== key);
      formik.setFieldValue('default_values', filterArray);
    }
  };

  // const handleInputs = (evt, key) => {
  //   const fieldsData = formik.values.default_values

  //   fieldsData[fieldsData.findIndex((obj) => obj.id === key)].level =
  //     evt.target.value;
  //   formik.setFieldValue('default_values', [...fieldsData]);

  // };
 const handleInputs = (evt, key) => {
    // ✅ Create a new array using .map for an immutable update
    const newFieldsData = formik.values.default_values.map(item => {
      if (item.id === key) {
        // This is the item we want to update. Return a new object.
        return { ...item, level: evt.target.value };
      }
      // This is not the item. Return it as is.
      return item;
    });

    formik.setFieldValue('default_values', newFieldsData);
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }

  };

  return (
    <>
      <Form
        layout="vertical"
        onFinish={formik.handleSubmit}
        className="modal-form custom-form expForm"
      >
        <Form.Item
          label="Label Name"
          required={true}
          rules={[
            {
              required: true,
              message: "Please enter name",
            },
          ]}
        >
          <Input
            placeholder="Label name"
            name="column_name"
            value={formik.values.column_name}
            maxLength={50}
            onChange={(e) => {
              formik.setFieldValue('column_name', e.target.value.trimStart())
            }}
          />
          {formik.touched.column_name && <div className="errorMsg">{formik.errors.column_name}</div>}
        </Form.Item>
        <Form.Item label="Data Type" required={true} rules={[{ required: true, message: 'Please select value' }]}>
          <Select
            name="column_type"
            value={formik.values.column_type}
            placeholder="Select Column Type"
            // onChange={(val) => setSelectedDataType(val)}
            onChange={(val) => {
              formik.setFieldValue('column_type', val)
            }}
          >
            <Option value="string">Text Box (Single Line)</Option>
            <Option value="integer">Number (123..)</Option>
            <Option value="dropdown">Dropdown</Option>
            {/* <Option value="checkbox">Check Box</Option>
                  <Option value="multicheckbox">Multi Select</Option> */}
          </Select>
          {formik.touched.column_type && <div className="errorMsg">{formik.errors.column_type}</div>}

        </Form.Item>
        {formik.values.column_type === "dropdown" ? (
          <Form.Item label="Default Value">
            <div className="optionsContainer">
              <Row>
                {formik.values?.default_values?.map((item, index) =>
                  <div key={item.id} className="fieldsDiv mt1">
                    <span className="inlineItem levelTitle">
                      Options {index + 1}
                    </span>
                    <Input
                      className="inlineItem"
                      onChange={(e) => handleInputs(e, item.id)}
                      value={item.level}
                      onKeyDown={handleKeyDown}

                    />
                    <MinusCircleOutlined
                      className="minusButton inlineItem mtHalf cursor ml2"
                      onClick={() => handleFields("remove", item.id)}
                    />
                  </div>
                )}
              </Row>
              <Button
                type="link"
                className="addFieldButton mt2"
                onClick={() => handleFields("add")}
              >
                <PlusCircleOutlined /> ADD OPTION
              </Button>
            </div>
            {formik.touched.default_values && formik.errors.default_values?.length && <div className="errorMsg">{"Options are required"}</div>}

          </Form.Item>
        ) : null}
        <Row>
          <Col span={24}>
            <Form.Item valuePropName="checked">
              <Checkbox
                name="is_required"
                checked={formik.values.is_required}
                onChange={(e) => {
                  formik.setFieldValue("is_required", e.target.checked);
                }}
              >
                Is Mandatory
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Checkbox
                checked={formik.values.isCat}
                name="categories"
                onChange={(e) => {
                  formik.setFieldValue("isCat", e.target.checked);
                  if (!e.target.checked) {
                    formik.setFieldValue("categories", []);
                  }
                }}

              >
                Apply for specific expense categories
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        {formik.values.isCat && (
          <Row>
            <Col span={24}>
              <Form.Item
                label="Categories"
                valuePropName="checked"
              >
                <InputSelect
                  options={
                    categories
                      ? categories.map((ele) => ({
                        label: ele.name,
                        value: ele.id,
                      }))
                      : []
                  }
                  isAll={isAll}
                  setIsAll={setIsAll}
                  isFilter={true}
                  values={formik.values.categories}

                  onChange={(vals) => {
                    formik.setFieldValue("categories", vals);
                  }}
                />
                {formik.touched.categories && <div className="errorMsg">{formik.errors.categories}</div>}

              </Form.Item>
            </Col>
          </Row>
        )}

        <Button key="1" htmlType="submit" className="formButton mt2">
          {currentId ? "Update" : "Save"}
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt2"
          onClick={() => handleCancelButton()}
        >
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default AddExpenseField;
